/**
 * This file specifically for rule engine
 */
import { isNullOrUndefined } from 'util';
import DefaultTooltip from '~/constants/tooltip-defaults';
import DebtManagementSavingDetail from '~/constants/debt-management-tooltip';
import splitterUrlEnv from '~/helpers/splitter-url-env';

export default {
    props: {
        dmaInputs: {
            default: null,
        },
        debtSettlementSavingTooltip: {
            default: DefaultTooltip.DebtSettlementSaving,
        },
        balanceTransferSavingTooltip: {
            default: DefaultTooltip.BalanceTransferSaving,
        },
        homeEquitySavingTooltip: {
            default: DefaultTooltip.HomeEquitySaving,
        },
        personalLoanSavingTooltip: {
            default: DefaultTooltip.PersonalLoanSaving,
        },
    },
    data() {
        return {
            DMAInputs: this.dmaInputs,
            DataFromAPI: null,
            Section3Data: {
                timeToDebtFreeData: [],
                monthlyPaymentData: [],
                highestSavingsData: [],
                chartTimeToDebtFreeGraph: {},
                chartMonthlyPayScheduleGraph: {},
                chartHighestSavingsGraph: {},
            },
            SavingsJson: [],
            timeToDebtFreeData: [],
            monthlyPaymentData: [],
            highestSavingsData: [],
            debtOptions: [
                { key: 'debtSavingSettlement', label: 'Debt Settlement' },
                { key: 'balanceTransferCard', label: 'Balance Transfer Card' },
                { key: 'homeEquityLoan', label: 'Home Equity Loan' },
                { key: 'personalLoan', label: 'Personal Loan' },
            ],
        };
    },
    methods: {
        formatDataForSections(dataFromAPI) {
            // Data for section 2, section 3, section 4 will be formatted here and set into respective data objects
            this.timeMoneySectionMapping(dataFromAPI);
            this.savingBreakDownMapping(dataFromAPI);
        },
        getDebtOptionstData(response) {
            let dataKey = [];
            this.debtOptions.forEach((debt) => {
                dataKey = response.result[debt.key];
                if (dataKey) {
                    this.timeToDebtFreeData.push({ name: debt.label, months: dataKey.timeToDebtFreeInMonths });
                    this.monthlyPaymentData.push({ name: debt.label, amount: dataKey.monthlyPayment });
                    this.highestSavingsData.push({ name: debt.label, amount: dataKey.totalSaving });
                }
            });
        },
        moveItemAtBottom(sortedData, propName, value) {
            let i;
            let temp;
            let keyData;
            for (i = sortedData.length - 1; i >= 0; i--) {
                keyData = propName ? sortedData[i][propName] : sortedData[i];
                if (keyData === value) {
                    temp = sortedData.splice(i, 1);
                    sortedData.push(temp[0]);
                }
            }
        },
        barChartSorting(debtOption, propName, isAscending) {
            let sortedData = debtOption.sort((col1, col2) => {
                const first = propName ? col1[propName] : col1;
                const second = propName ? col2[propName] : col2;
                if (first < second) return -1;
                if (first > second) return 1;
                return 0;
            });
            if (!isAscending) sortedData.reverse();
            // move zero items at last index
            this.moveItemAtBottom(sortedData, propName, null);

            sortedData = sortedData.sort((col1, col2) => {
                let result = 0;
                if (col1[propName] === col2[propName]) {
                    if (col1.name < col2.name) {
                        result = -1;
                    }
                    if (col1.name > col2.name) {
                        result = 1;
                    }
                    result = 0;
                }
                return result;
            });
            return sortedData;
        },
        getBarChartData(debtOption, keyName) {
            const dateSet = [];
            debtOption.forEach((debt) => {
                dateSet.push(debt[keyName] === null ? '0' : debt[keyName]);
            });
            return dateSet;
        },
        timeMoneySectionMapping(response) {
            if (!response || !response.result) return;

            // To bind DMA data
            this.getDebtOptionstData(response);
            // TimeToDebtFreeData Tab-1
            // barChartSorting(timeToDebtFreeData, 'months', true); //do srting months data based on lowest months to highest.
            // Monthly Payment Tab-2
            // barChartSorting(monthlyPaymentData, 'amount', true); //do sorting monthlyPayment data based on lowest payment to highest payment.
            // Highest Savings Tab-3
            // barChartSorting(highestSavingsData, 'amount', false); //do sorting totalSaving data based on highest savings to lowest saving.
            this.Section3Data = {
                timeToDebtFreeData: this.timeToDebtFreeData, // Tab-1 (data)
                monthlyPaymentData: this.monthlyPaymentData, // Tab-2 (data)
                highestSavingsData: this.highestSavingsData, // Tab-3 (data)
                // timeToDebtFreeData, // Tab-1 (data)
                // monthlyPaymentData, // Tab-2 (data)
                // highestSavingsData, // Tab-3 (data)
                chartTimeToDebtFreeGraph: { // Tab-1 (Bar Chart)
                    labels: this.getBarChartData(this.timeToDebtFreeData, 'name'),
                    datasets: [
                        {
                            backgroundColor: '#7ac142',
                            hoverBackgroundColor: '#28975d',
                            data: this.getBarChartData(this.timeToDebtFreeData, 'months'),
                            maxBarThickness: 35,
                        },
                    ],
                },
                chartMonthlyPayScheduleGraph: { // Tab-2 (Bar Chart)
                    labels: this.getBarChartData(this.monthlyPaymentData, 'name'),
                    datasets: [
                        {
                            backgroundColor: '#0096e0',
                            hoverBackgroundColor: '#0064b3',
                            data: this.getBarChartData(this.monthlyPaymentData, 'amount'),
                            maxBarThickness: 35,
                        },
                    ],
                },
                chartHighestSavingsGraph: { // Tab-3 (Bar Chart)
                    labels: this.getBarChartData(this.highestSavingsData, 'name'),
                    datasets: [
                        {
                            backgroundColor: '#ffc42a',
                            hoverBackgroundColor: '#ffa800',
                            data: this.getBarChartData(this.highestSavingsData, 'amount'),
                            maxBarThickness: 35,
                        },
                    ],
                },
            };
        },
        savingBreakDownMapping(response) {
            let queryString = window.location.search.substring(1);
            queryString = queryString ? `&${queryString}` : '';
            this.SavingsJson = [];
            let calculatedValues = {};
            if (!response || !response.result) return;
            if (response.result.currentDebtStatus) {
                calculatedValues = {
                    creditCardMonthlyPayment: response.result.currentDebtStatus.creditCardMonthlyPayment,
                    personalLoanMonthlyPayment: response.result.currentDebtStatus.personalLoanMonthlyPayment,
                    creditCardTotalInterest: response.result.currentDebtStatus.creditCardTotalInterest,
                    personalLoanTotalInterest: response.result.currentDebtStatus.personalLoanTotalInterest,
                };
            }
            if (response.result.debtSavingSettlement) {
                calculatedValues.response = response.result.debtSavingSettlement;
                calculatedValues.savingName = 'Debt Settlement';
                calculatedValues.buttonText = 'Get Debt Settlement Offers';
                calculatedValues.detailText = DebtManagementSavingDetail['debt-settlement-detail'];
                calculatedValues.toolTipText = parseInt(this.hideTooltip, 10) ? '' : this.debtSettlementSavingTooltip;
                calculatedValues.targetURL = `${splitterUrlEnv.getSplitterURL()}/api/split?id=dr-dma-dr${queryString}`;
                this.SavingsJson.push(this.getSavingBreakdownJson(calculatedValues));
            }
            if (response.result.personalLoan) {
                calculatedValues.response = response.result.personalLoan;
                calculatedValues.savingName = 'Personal Loan';
                calculatedValues.buttonText = 'Get Personal Loan Offers';
                calculatedValues.detailText = DebtManagementSavingDetail['personal-loan-detail'];
                calculatedValues.toolTipText = parseInt(this.hideTooltip, 10) ? '' : this.personalLoanSavingTooltip;
                calculatedValues.targetURL = `${splitterUrlEnv.getSplitterURL()}/api/split?id=dr-dma-pl${queryString}`;
                this.SavingsJson.push(this.getSavingBreakdownJson(calculatedValues));
            }
            if (response.result.balanceTransferCard) {
                calculatedValues.response = response.result.balanceTransferCard;
                calculatedValues.savingName = 'Balance Transfer Card';
                calculatedValues.buttonText = 'Compare Balance Transfer Cards';
                calculatedValues.detailText = DebtManagementSavingDetail['balance-transfer-card-detail'];
                calculatedValues.toolTipText = parseInt(this.hideTooltip, 10) ? '' : this.balanceTransferSavingTooltip;
                calculatedValues.targetURL = `${splitterUrlEnv.getSplitterURL()}/api/split?id=dr-dma-cc${queryString}`;
                this.SavingsJson.push(this.getSavingBreakdownJson(calculatedValues));
            }
            if (response.result.homeEquityLoan) {
                calculatedValues.response = response.result.homeEquityLoan;
                calculatedValues.savingName = 'Home Equity Loan';
                calculatedValues.buttonText = 'Get Home Equity Offers';
                calculatedValues.detailText = DebtManagementSavingDetail['home-equity-detail'];
                calculatedValues.toolTipText = parseInt(this.hideTooltip, 10) ? '' : this.homeEquitySavingTooltip;
                calculatedValues.targetURL = `${splitterUrlEnv.getSplitterURL()}/api/split?id=dr-dma-he${queryString}`;
                this.SavingsJson.push(this.getSavingBreakdownJson(calculatedValues));
            }
            this.SavingsJson = this.SavingsJson.sort((a, b) => a.rank - b.rank);
        },
        getSavingBreakdownJson(calculatedValues) {
            const savingBreakdownJson = {
                savingName: calculatedValues.savingName,
                debtAmount: calculatedValues.response.debtCovered.total,
                debtNotCovered: calculatedValues.response.debtNotCovered.total,
                debtFreeBy: calculatedValues.response.timeToDebtFreeInMonths,
                interest: calculatedValues.response.totalInterest,
                monthlyPayment: calculatedValues.response.monthlyPayment,
                totalSavings: calculatedValues.response.totalSaving,
                buttonText: calculatedValues.buttonText,
                toolTipText: calculatedValues.toolTipText,
                targetURL: calculatedValues.targetURL,
                outstandingDebtPayments: [],
                rank: calculatedValues.response.rank,
            };
            if (calculatedValues.response.debtCovered) {
                if (!isNullOrUndefined(calculatedValues.response.debtCovered.creditCard)) {
                    savingBreakdownJson.outstandingDebtPayments.push({
                        detailText: calculatedValues.detailText,
                        debtPaymentType: 'Credit Card Debt',
                        debtAmount: calculatedValues.response.debtCovered.creditCard,
                        interest: calculatedValues.creditCardTotalInterest,
                        monthlyPayment: calculatedValues.creditCardMonthlyPayment,
                    });
                }
                if (!isNullOrUndefined(calculatedValues.response.debtCovered.personalLoan)) {
                    savingBreakdownJson.outstandingDebtPayments.push({
                        debtPaymentType: 'Personal Loan Debt',
                        debtAmount: calculatedValues.response.debtCovered.personalLoan,
                        interest: calculatedValues.personalLoanTotalInterest,
                        monthlyPayment: calculatedValues.personalLoanMonthlyPayment,
                    });
                }
                if (!isNullOrUndefined(calculatedValues.response.debtCovered.medical)) {
                    savingBreakdownJson.outstandingDebtPayments.push({
                        debtPaymentType: 'Medical Bill',
                        debtAmount: calculatedValues.response.debtCovered.medical,
                    });
                }
                if (!isNullOrUndefined(calculatedValues.response.debtCovered.other)) {
                    savingBreakdownJson.outstandingDebtPayments.push({
                        debtPaymentType: 'Other Debt',
                        debtAmount: calculatedValues.response.debtCovered.other,
                    });
                }
            }
            return savingBreakdownJson;
        },
    },
};
